import type { GroupedProperty, ListingUnit } from "../../services/emailService";

const priceFields = ["current_price", "status", "available_date", "available_count", "price_display"] as const;
const key = (unit: ListingUnit) => JSON.stringify([unit.property_id, unit.id]);

/** Refresh only authoritative inventory fields. Never resurrect a removed row,
 * overwrite operator text/sqft/specials edits, or replace a selected unit with a
 * different one. A disappeared selection remains visible but cannot quote rent.
 */
export function revalidateListingDraft(
  listings: ListingUnit[], groupedProperties: GroupedProperty[], fresh: ListingUnit[]
): { listings: ListingUnit[]; groupedProperties: GroupedProperty[]; changed: boolean } {
  const byId = new Map(fresh.map((unit) => [key(unit), unit]));
  let changed = false;
  const refresh = (unit: ListingUnit): ListingUnit => {
    const current = byId.get(key(unit));
    const prices = current ? {
      current_price: current.current_price,
      status: current.status,
      available_date: current.available_date,
      available_count: current.available_count,
      price_display: current.price_display,
    } : {
      current_price: 0, status: "unknown", available_date: undefined,
      available_count: 0, price_display: undefined,
    };
    if (priceFields.some((field) => !Object.is(unit[field], prices[field]))) changed = true;
    return { ...unit, ...prices };
  };
  return {
    listings: listings.map(refresh),
    groupedProperties: groupedProperties.map((property) => ({ ...property, units: property.units.map(refresh) })),
    changed,
  };
}
